<template>
  <BaseDialog
    v-model="showDialog"
    dialogIcon="mdi-account-edit"
    title="Ny kontaktperson"
    subtitle="Inviter kontaktperson for firma"
    btnActionName="Send invitasjon"
    @action="save"
  >
    <template v-slot>
      <v-form ref="form" v-model="valid" autocomplete="off">
        <v-text-field
          v-model="person.firstName"
          class="textFieldError"
          prepend-inner-icon="mdi-account-outline"
          color="primary"
          label="Fornavn (Obligatorisk)"
          filled
          autocomplete="off"
          :rules="[(v) => !!v || 'Fornavn må fylles ut!']"
          required
        ></v-text-field>
        <v-text-field
          v-model="person.lastName"
          class="textFieldError"
          prepend-inner-icon="mdi-account-outline"
          color="primary"
          label="Etternavn (Obligatorisk)"
          filled
          autocomplete="off"
          :rules="[(v) => !!v || 'Etternavn må fylles ut!']"
          required
        ></v-text-field>
        <v-text-field
          v-model="person.email"
          class="textFieldError"
          prepend-inner-icon="mdi-email-outline"
          color="primary"
          label="Epost (Obligatorisk)"
          filled
          autocomplete="off"
          :rules="[(v) => !!v || 'Epost må fylles ut!']"
          required
          type="email"
        ></v-text-field>
        <v-text-field
          v-model="person.mobile"
          class="textFieldError"
          prepend-inner-icon="mdi-cellphone"
          color="primary"
          label="Mobil (Obligatorisk)"
          filled
          autocomplete="off"
          :rules="[(v) => !!v || 'Mobil må fylles ut!']"
          required
          pattern="[0-9]*"
        ></v-text-field>
        <v-text-field
          v-model="person.title"
          class="textFieldError"
          prepend-inner-icon="mdi-account-hard-hat"
          color="primary"
          label="Tittel"
          filled
          autocomplete="off"
          hide-details
        ></v-text-field>
      </v-form>
    </template>
  </BaseDialog>
</template>

<script lang="ts">
import Vue from "vue";
import notification from "@/helpers/notification";
import BaseDialog from "@/components/shared/dialog/BaseDialog.vue";

export default Vue.extend({
  name: "AddContactDialog",
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    activeContactId: {
      required: true,
    },
  },
  data() {
    return {
      valid: true,
      person: {
        firstName: "",
        lastName: "",
        email: null,
        mobile: null,
        title: null,
      },
    };
  },
  methods: {
    async save() {
      const isValid = this.form?.validate();
      if (isValid) {
        var contactPerson = {
          activeContactId: this.activeContactId,
          person: this.person,
        };

        this.$emit("addNewContact", contactPerson);
      } else {
        notification.warn("Alle obligatoriske felter må fylles ut!");
      }
    },
  },

  computed: {
    showDialog: {
      get(): boolean {
        return this.value;
      },
      set(value: boolean) {
        this.form.reset();
        this.$emit("input", value);
      },
    },
    form(): Vue & { validate: () => boolean; reset: () => boolean } {
      return this.$refs.form as Vue & {
        validate: () => boolean;
        reset: () => boolean;
      };
    },
  },

  components: {
    BaseDialog,
  },
});
</script>

<style lang="scss">
.textFieldError {
  .v-input__control .v-text-field__details {
    margin-bottom: 0px;
  }
}
</style>
